import WIP from "../components/WIP/WIP";

const WhyEnvironment = () => {
  return (
    <div>
      <WIP />
    </div>
  );
};

export default WhyEnvironment;
